import missionService from "@/services/mission";
import Utils from "@/mixins/Utils";
import { mapGetters } from "vuex";
export default {
  name: "MissionDetail",
  props: ["mission"],
  data() {
    return {
      hasApplied: false,
      cantApply: false,
      cantApplyMessage: "",
      isApplying: false,
      isCancelling: false,
      isCancelled: false,
      isCancelledMessage: "",
      extension: "",
      btnWidth: null
    };
  },
  computed: {
    ...mapGetters('auth', {
      generalSetting : 'generalSetting'
    }),
    isLoggedIn() {
      return localStorage.getItem("isAuthenticated");
    },
    detailRoute() {
      return (/^\/public/.test(this.$route.path) ? '' : 'candidate-') + 'job-offer-details';
    },
    applyRoute() {
      return (/^\/public/.test(this.$route.path) ? '' : 'candidate-') + 'sign-up';
    }
  },
  mixins: [Utils],
  created() {
    setTimeout(()=> {
      this.setBtnWidth();
    })
  },
  methods: {
    redirectToPostTulerUrl() {
      if(this.generalSetting.redirectPageToApply) {
        window.location.replace(this.generalSetting.redirectPageToApply)
      } else {
        this.$router.push({
          name: this.applyRoute,
          query: { 
            id: this.mission.idJobOffer,
            ...this.$route.query
          },
        })
      }
    },
    setBtnWidth() {
      if (!this.$refs.detailBtn || !this.$refs.applyBtn) {
        return;
      }
      const detailBtnWidth = this.$refs.detailBtn.offsetWidth;
      const applyBtnWidth = this.$refs.applyBtn.offsetWidth;
      this.btnWidth = detailBtnWidth > applyBtnWidth ? detailBtnWidth : applyBtnWidth
      this.btnWidth += 1;
      
    },
    postulerOffre(pkM) {
      const vue = this;
      const data = {
        pkMissions: pkM,
      };
      this.isApplying = true;
      this.isCancelled = false;
      missionService
        .applyMission(data)
        .then((res) => {
          if (res.success) {
            vue.hasApplied = true;
            return;
          }
          vue.cantApply = true;
          vue.cantApplyMessage = res.message;
        })
        .catch((err) => {
          vue.callToaster(vue.$t('problem-arise'));
        })
        .finally(() => {
          vue.isApplying = false;
        });
    },
    annulerOffe(pkM) {
      const vue = this;
      const data = {
        pkMissions: pkM,
      };
      this.hasApplied = false;
      missionService
        .cancelOffer(data)
        .then((res) => {
          if (res.success) {
            vue.hasApplied = false;
            vue.isCancelled = true;
            vue.isCancelledMessage = res.message;
          }
        })
        .catch((err) => {
          vue.callToaster(vue.$t('problem-arise'));
        })
        .finally(() => {
          vue.isCancelling = false;
        });
    },
  },
};
